module.exports = __webpack_public_path__ + "img/Slajd11.0e8f1330.jpeg";